import http from '../utils/api';

export function apagarAnexo(file) {
    return http.delete('/apontamentos/anexos',
        {
            params: {
                anexo: file
            }
        }).then(({data}) => data)
}

export function enviarAnexo(formData) {
    return http.post('/apontamentos/anexos',
        formData,
        {
            headers: {
                'Content-Type': `multipart/form-data`
            }
        }).then(({data}) => data)
}

export function receberAnexo(filename) {
    return http.get('/apontamentos/anexos',
        {
            responseType: 'arraybuffer',
            params: {
                anexo: filename
            }
        }).then(({headers, data}) => {
        if (data.error)
            throw new Error();
        let image = btoa(
            new Uint8Array(data)
                .reduce((data, byte) => data + String.fromCharCode(byte), '')
        );
        return `data:${headers['content-type'].toLowerCase()};base64,${image}`;
    })
}
